var map = {
	"./app_strings.json": 12645,
	"./client/account_client.json": 73929,
	"./client/common_client.json": 71827,
	"./client/console.json": 10114,
	"./client/consultation_client.json": 98005,
	"./client/eyes.json": 94852,
	"./client/nav_client.json": 41292,
	"./client/patient_client.json": 77212,
	"./client/pdf.json": 99001,
	"./client/stats_client.json": 79411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45928;